import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getCurrencies = ({ pageNumber = 1 }) => {
  return axios.get(`/currency/active/${pageNumber}`);
};

export const useSystemCurrencies = ({ pageNumber = 1, config }) => {
  return useQuery({
    ...config,
    queryKey: ['system_currencies', pageNumber],
    queryFn: () => getCurrencies({ pageNumber }),
  });
};
